import { Text } from 'platform-components';
import React, { useMemo } from 'react';
import { connect } from 'react-redux';

import * as lessonViewSelectors from 'common.components/lesson-view.store/selectors';
import * as problemsViewSelectors from 'store/problems-view/selectors';
import * as problemSelectors from 'store/problems/selectors';
import { ProblemInCourse } from 'store/problems/typings';

import * as selectors from '../selectors';

import './problem-view__variants.scss';

interface StoreProps {
    hasVariants: boolean;
    problems: Array<ProblemInCourse>;
    selectedProblemId: number | null;
}

interface Props extends StoreProps {}

export const ProblemViewVariantsHeader = ({ hasVariants, problems, selectedProblemId }: Props) => {
    let selectedProblemIndex = useMemo(
        () => problems.findIndex((p) => p.problem?.id === selectedProblemId),
        [problems, selectedProblemId]
    );

    if (!hasVariants) {
        return null;
    }

    const numberUsageCardInCourse =
        problems.find((problem) => problem.problem?.id === selectedProblemId)?.inCourse?.length || 0;

    return (
        <div className="problem-view__variants-counter">
            <Text
                id="problemView.variantsCounter"
                values={{ total: problems.length, count: selectedProblemIndex + 1 }}
            />
            {numberUsageCardInCourse > 0 && (
                <div className="problem-view__variant-usage">
                    <Text id="problemView.variantUsage" values={{ number: numberUsageCardInCourse }} />
                </div>
            )}
        </div>
    );
};

const mapStateToProps = (storeState: any): StoreProps => {
    const stackId = lessonViewSelectors.getProblemStackId(storeState);

    return {
        hasVariants: selectors.getHasVariants(storeState, { stackId }),
        selectedProblemId: problemsViewSelectors.getSelectedProblemId(storeState),
        problems: problemSelectors.getProblemsWithUsage(storeState, { stackId }),
    };
};

export default connect(mapStateToProps)(ProblemViewVariantsHeader);
